class Module {
    async load(node = false) {
        if (this._ergo === undefined) {
            this._ergo = await (node ? import("ergo-lib-wasm-nodejs") : import("ergo-lib-wasm-browser"));
        }
        return this._ergo;
    }
    // Need to expose through a getter to get Flow to detect the type correctly
    get SigmaRust() {
        return this._ergo;
    }
}
// need this otherwise Wallet's flow type isn't properly exported
export const RustModule = new Module();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicnVzdExvYWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9ydXN0TG9hZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sTUFBTTtJQUdWLEtBQUssQ0FBQyxJQUFJLENBQUMsT0FBZ0IsS0FBSztRQUM5QixJQUFJLElBQUksQ0FBQyxLQUFLLEtBQUssU0FBUyxFQUFFO1lBQzVCLElBQUksQ0FBQyxLQUFLLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLHNCQUFzQixDQUFDLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyx1QkFBdUIsQ0FBQyxDQUFDLENBQUE7U0FDN0Y7UUFDRCxPQUFPLElBQUksQ0FBQyxLQUFNLENBQUE7SUFDcEIsQ0FBQztJQUVELDJFQUEyRTtJQUMzRSxJQUFJLFNBQVM7UUFDWCxPQUFPLElBQUksQ0FBQyxLQUFNLENBQUE7SUFDcEIsQ0FBQztDQUNGO0FBRUQsaUVBQWlFO0FBQ2pFLE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBVyxJQUFJLE1BQU0sRUFBRSxDQUFBIn0=